import { Component, ReactNode } from "react";

import { trackException } from "../../../../utils/appInsights";
import { GlobalErrorFallback } from "./GlobalErrorFallback";

import "./GlobalErrorBoundary.scss";

interface IGlobalErrorBoundaryProps {
  children: ReactNode;
}

interface IGlobalErrorBoundaryState {
  hasError: boolean;
  error: Error | null;
}

export class GlobalErrorBoundary extends Component<IGlobalErrorBoundaryProps, IGlobalErrorBoundaryState> {
  constructor(props: IGlobalErrorBoundaryProps) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error: Error): IGlobalErrorBoundaryState {
    return { hasError: true, error };
  }

  componentDidCatch(error: Error, info: React.ErrorInfo): void {
    trackException(error, info.componentStack ?? "GlobalErrorBoundary");
  }

  render(): ReactNode {
    if (this.state.hasError) {
      return <GlobalErrorFallback error={this.state.error} />;
    }

    return this.props.children;
  }
}
